import React from 'react'
import { Link } from 'react-router-dom'
import "./style/subfooter.css"
export default function Subfooter() {
  return (
    <div className='footerr'>
        <Link to="/privacypolicy">Privacy and policy</Link>
        <Link to="/termsandconditions">Terms & Conditions</Link>
        <Link to="/disclaimer">Disclaimer</Link>
    </div>
  )
}
